<div id="verification-container" *ngIf="!isLoading"></div>
<div class="d-flex justify-content-center align-items-center h-100" *ngIf="isLoading">
    <app-spinner [isLoading]="isLoading"></app-spinner>
</div>
